module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.searchClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入您要搜索的内容"
    },
    domProps: {
      "value": _vm._s(_vm.keyword)
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "searchBtn",
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "searchResult"
  }, [(_vm.isResultEmpty) ? _c('ul', {
    staticClass: "none"
  }, [_vm._v("暂无搜索结果，尝试更换关键字")]) : _c('ul', [_vm._l((_vm.searchProduct), function(item, index) {
    return _c('router-link', {
      attrs: {
        "to": {
          name: 'product-detail',
          params: {
            serialId: item.serialId
          }
        }
      }
    }, [_c('li', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.classificationName))])])])
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [(_vm.hasMore) ? _c('li', [_vm._v("......")]) : _vm._e()])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b933210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 1031
// module chunks = 40